import { render } from "./AddonViewIndex.vue?vue&type=template&id=90ef604e&scoped=true&ts=true"
import script from "./AddonViewIndex.vue?vue&type=script&lang=ts"
export * from "./AddonViewIndex.vue?vue&type=script&lang=ts"

import "./AddonViewIndex.vue?vue&type=style&index=0&id=90ef604e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90ef604e"]])

export default __exports__